<template>
  <div id="app">
    <router-view />
  </div>

</template>

<script>
import {signOut} from "./utils/auth";

export default {
  created () {
    window.addEventListener('beforeunload', this.closed_sign_out)
  },
  methods: {
    closed_sign_out() {
      signOut();
    }
  },
}
</script>
